export const MANAGER_EMPLOYEES = "manager-employees";
export const LOCATIONS = "locations";
export const CLIENTS = "clients";
export const WORK_ORDER_INDEX = "work-order-index";
export const OMEGA_DRIVE = "omega-drive";

export const DEBOUNCE_DELAY = 500;
export const MIN_SEARCH_LENGTH = 3;
